<section>
  <mat-card>
    <mat-card-content class="wrap-content">
      <div class="content">
        <div class="prop-img">
          <a *ngIf="mainPhotoIsClickable; else noClickPhoto" (click)="onMainPhotoClick()"
            [appTooltip]="mainPhotoTooltip"><img [src]="mainPhoto" alt="Photo principale du bien" /></a>
          <ng-template #noClickPhoto>
            <img [src]="mainPhoto" alt="Photo principale du bien" />
          </ng-template>
        </div>
        <div class="right">
          <div id="icons">
            <app-certification-badge [prop]="prop" [class.separator]="prop.certified"></app-certification-badge>
            <ul class="row-list">
              <li *ngIf="isInCondo">
                <mat-icon color="accent" appTooltip="Fait partie d'une copropriété"
                  aria-label="Fait partie d'une copropriété" class="small-icon">{{condoBadgeImageName}}</mat-icon>
              </li>
              <li *ngIf="!userHelper.isPropertyOwner(prop) && userHelper.canUpdateProperty(prop)">
                <mat-icon color="accent" appTooltip="Droits d'accès en délégation sur le bien"
                  aria-label="Droits d'accès en délégation sur le bien" class="small-icon">vpn_key</mat-icon>
              </li>
              <li>
                <mat-icon color="accent" class="small-icon"
                  [appTooltip]="'enum.PropertyType.' + prop.type | translate">{{badgeImageName}}</mat-icon>
              </li>
            </ul>
          </div>
          <div class="prop-desc">
            <h1 class="title">{{ prop.name}}</h1>
            <p class="subtitle" *ngIf="!isPropertyOwner">{{ propertySubTitle }}</p>
            <div class="desc">{{ propertyDesc | async }}</div>
            <div *ngIf="isOnSelling" class="price">{{price | currency: 'EUR':'symbol':'1.0' }}</div>
            <div *ngIf="prop.certified && prop.certificationType!=='INHERITED'" class="dropbox">
              <a (click)="showDropBoxInfo()" appTooltip="Plus d'informations" class="more-info">
                <mat-icon class="align-top info" color="primary" aria-label="Plus d'informations">info</mat-icon>
              </a>
              <span class="ml-2 address-depot">Adresse de dépôt </span>
              <a href="mailto:{{dropBoxAddress}}" class="text-nowrap">{{dropBoxAddress}}</a>
            </div>
            <div *ngIf="prop.parent && !isCondoPropParent" class="m-3 prop-parent">
              <span>Lié à </span>
              <a [routerLink]="['/property', prop.parent.uid]" appTooltip="Voir le bien parent">
                <mat-icon color="primary" class="mr-1 align-bottom">{{ parentBadgeImageName }}</mat-icon>
                {{ prop.parent.name }}
              </a>
            </div>
          </div>
        </div>
        <div *ngIf="prop.demo" class="banner demo">
          <span>DEMO</span>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</section>
